import { useMemo } from "react";

import type { ActivationAlertsContractSocialMediaChannel } from "@similarweb/pro-api-client";

import { useApiQuery } from "app/modules/api-client";

import { useActivationSet } from "../../../hooks/useActivationSet";
import { useCommonAlertsQueryParams } from "../../useCommonAlertsQueryParams";
import { useSocialAlertsFilterStore } from "../filters/useSocialAlertsFilterStore";
import { transformSocialMediaMetricsOverTimeData } from "../utils/transformSocialMediaMetricsOverTimeData";

export const useSocialMediaMetricsOverTimeData = () => {
    const params = useCommonAlertsQueryParams();
    const { activationSet, isLoading: isActivationSetLoading } = useActivationSet();

    const selectedChannels = useSocialAlertsFilterStore((state) => state.selectedChannels);
    const isDefaultChannelsSelected = useSocialAlertsFilterStore((state) => state.isDefaultChannelsSelected);
    const socialNetworks = isDefaultChannelsSelected
        ? undefined
        : ([...selectedChannels.keys()] as ActivationAlertsContractSocialMediaChannel[]);

    const {
        data,
        isLoading: isDataLoading,
        isError,
    } = useApiQuery(
        {
            tag: "Alerts",
            methodName: "activationAlertsMetricsSocialMediaMetricsOverTimeDetail",
            options: {
                refetchOnMount: true,
            },
        },
        {
            ...params,
            socialNetworks,
        },
    );

    const transformedData = useMemo(() => {
        if (!data) {
            return [];
        }

        return transformSocialMediaMetricsOverTimeData({
            data: data.data,
            primaryDomain: activationSet?.primaryDomain,
        });
    }, [activationSet?.primaryDomain, data]);

    return {
        data: transformedData,
        primaryDomain: activationSet?.primaryDomain,
        isError,
        isLoading: isActivationSetLoading || isDataLoading,
        isMonthly: data?.grouping === "Monthly",
    };
};
